import { Link, useParams } from 'react-router-dom';
import { listCatalog, type CatalogEntry } from '@core/shortcut-helpers';

export function ShortcutDetailRoute() {
  const { slug } = useParams<{ slug: string }>();
  const all: CatalogEntry[] = listCatalog('vi');
  const entry = all.find((e) => e.shortcut_id === slug);

  if (!entry) {
    return (
      <main style={{ maxWidth: 560, margin: '96px auto', padding: '0 16px', textAlign: 'center' }}>
        <h1>Shortcut không tồn tại</h1>
        <p style={{ color: 'var(--color-muted)' }}>
          Slug "<code>{slug}</code>" không nằm trong catalog Day-1.
        </p>
        <Link className="cta-primary" to="/shortcut">
          {'<- '}Tất cả Shortcut
        </Link>
      </main>
    );
  }

  return (
    <main style={{ maxWidth: 720, margin: '48px auto', padding: '0 16px' }}>
      <p style={{ marginBottom: 8 }}>
        <Link to="/shortcut" style={{ color: 'var(--color-muted)', fontSize: 14 }}>
          {'<- '}Tất cả Shortcut
        </Link>
      </p>
      <p
        style={{
          fontFamily: 'var(--font-mono, monospace)',
          fontSize: 12,
          color: 'var(--color-muted)',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          marginBottom: 4,
        }}
      >
        {entry.segment} - {entry.step_count} bước - ~{entry.est_minutes} phút
      </p>
      <h1 style={{ marginTop: 0 }}>{entry.title_vn}</h1>
      <p style={{ color: 'var(--color-muted)', fontSize: 16, lineHeight: 1.6, marginBottom: 24 }}>
        {entry.description_vn}
      </p>

      <div
        style={{
          padding: 20,
          border: '1px dashed var(--color-border, rgba(0,0,0,0.12))',
          borderRadius: 12,
          background: 'var(--color-card, #faf9f7)',
        }}
      >
        <h2 style={{ marginTop: 0, fontSize: 18 }}>Wizard sắp ra mắt</h2>
        <p style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.6 }}>
          Wizard {entry.step_count} bước cho "{entry.title_vn}" đang trong giai đoạn beta. Trong khi
          chờ, bạn có thể hỏi trực tiếp Asklaw - mọi câu trả lời đều kèm citation Điều/Khoản.
        </p>
        <Link className="cta-primary" to={`/chat?from=shortcut-${entry.shortcut_id}`}>
          Hỏi Asklaw về chủ đề này
          <span className="arrow" aria-hidden>{'->'}</span>
        </Link>
      </div>
    </main>
  );
}
